import { ProductSlider } from "@repo/components";
import { getUpsellProducts } from "@repo/server-actions/product";
import { getTranslations } from "next-intl/server";
const UpsellProducts = async ({
  itemId,
  wishlistItems,
  session,
  locale
}) => {
  const products = await getUpsellProducts(itemId, locale);
  const t = await getTranslations("Common");
  if (!products.length) return;
  return <div className="mx-auto md:max-w-screen-xl" data-sentry-component="UpsellProducts" data-sentry-source-file="UpsellProducts.jsx">
      <ProductSlider title={t("You_May_Also_Like")} items={products} wishlistItems={wishlistItems} type="Upsell Products" isMedium session={session} data-sentry-element="ProductSlider" data-sentry-source-file="UpsellProducts.jsx" />
    </div>;
};
export default UpsellProducts;